import { useNavigate } from 'react-router-dom';
/** The header opens the shared Ethereum wallet connection. */
export function useSiweLogin(): { busy: boolean; connect: () => void } {
  const navigate = useNavigate();
  return { busy: false, connect: () => navigate('/connect') };
}
